import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
      <span className="w-16 h-16 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center">
        <i className="ri-film-line text-3xl" aria-hidden="true" />
      </span>
      <p className="mt-6 font-label text-5xl md:text-6xl font-semibold text-background-400">404</p>
      <h1 className="mt-4 text-xl md:text-2xl font-semibold text-foreground-950">这个页面没有找到</h1>
      <p className="mt-2 text-sm text-foreground-500">你访问的地址可能已变更或不存在</p>
      <p className="mt-2 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-5-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          浏览影片分类
        </Link>
      </div>
    </div>
  );
}